import { render, staticRenderFns } from "./CollectionItemList.vue?vue&type=template&id=740c3546&"
import script from "./CollectionItemList.vue?vue&type=script&lang=js&"
export * from "./CollectionItemList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports